import React from "react";

import MAudioBody from "./MAudioBody";
import MVoiceMessageBody from "./MVoiceMessageBody";
import { type IBodyProps } from "./IBodyProps";
import { isVoiceMessage } from "../../../utils/EventUtils";

export default class MVoiceOrAudioBody extends React.PureComponent<IBodyProps> {
    public render(): React.ReactNode {
        if (!this.props.forExport && isVoiceMessage(this.props.mxEvent)) {
            return <MVoiceMessageBody {...this.props} />;
        } else {
            return <MAudioBody {...this.props} />;
        }
    }
}
